// extracted by mini-css-extract-plugin
export var numpadContainer = "_m8-1";
export var phoneButton = "_m8-0";